import {
  Component,
  Injectable,
  Input,
  Output,
  OnInit,
  EventEmitter,
} from '@angular/core';
import { OverviewComponent } from './overview/overview.component';
import { LocationAndSiteConditionComponent } from './location-and-site-condition/location-and-site-condition.component';
import { BudgetAndTimelineComponent } from './budget-and-timeline/budget-and-timeline.component';
import { CommonModule } from '@angular/common';
import { TabbedScrollerComponent } from '../../../tabbed-scroller/tabbed-scroller.component';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
@Component({
  standalone: true,
  imports: [
    OverviewComponent,
    LocationAndSiteConditionComponent,
    BudgetAndTimelineComponent,
    CommonModule,
  ],
  selector: 'app-brief-sections',
  templateUrl: './brief-sections.component.html',
  styleUrls: ['./brief-sections.component.css'],
})
@Injectable({ providedIn: 'root' })
export class BriefSectionsComponent implements OnInit {
  @Input() currentStep!: number;
  @Input() projectId!: number | null;
  @Output() projectIdEmitter = new EventEmitter<number>();

  constructor(
    private TabbedScrollerComponent: TabbedScrollerComponent,
    private getProjectIdService: GetProjectIdService
  ) {}

  ngOnInit() {
    // this.getProjectIdService.projectId$.subscribe((id) => {
    //   this.projectId = Number(id);
    //   this.currentStep = 1;
    // });
    const projectId = this.getProjectIdService.getProjectId();
    this.projectId = Number(projectId);
    this.currentStep = this.TabbedScrollerComponent.currentStep;
  }

  receiveProjectId(id: number) {
    this.projectId = id;
    this.projectIdEmitter.emit(this.projectId);
  }
}
